import React , { useState, useEffect }from 'react';
import Modal from '../../../Components/Modal';
import {
    MDBRow,
    MDBCol
} from 'mdb-react-ui-kit';
import DragDrop from '../../../Components/DragDrop';
import Button from '../../../Components/Button';
import { SuccessAlert, ErrorAlert } from '../../../Components/Alert';
import useAxiosCall from '../../../Hooks/useAxiosCall';
import { decryptData } from '../../../Utilities/CryptoUtility';
import { getFileType } from '../../../Common';
import { ProgressBar } from '../../../Components/ProgressBar';
const UploadFile = ({isOpen, onClose, getUploadData}) => {
    const [formFiles, setformFiles] = useState([]);
    const [uploadInformation, setUploadInformation] = useState([]);
    const [allowedMimeTypes, setAllowedMimeTypes] = useState([]);
    const [allowedExtension, setAllowedExtension] = useState([]);
    const [allowedExtensionAsString, setAllowedExtensionAsString] = useState('');
    const [alert, setAlert] = useState({ type: '', message: '' });


    const { makeApiCall } = useAxiosCall();

    useEffect(()=> {
        getMediaUploadInformation();
    }, [isOpen]);

    const getMediaUploadInformation = async () => {
        const requestData = {
            //
        };
    
        try {
          await makeApiCall({
            requestData,
            onSuccess: handleApiUploadInformationCallSuccess,
            onError: handleApiCallError,
            requestType: 'GET',
            url: 'getMediaInformation',
            loader: false
          });
        } catch (error) {
            console.error('API call error:', error);
        }
    };
    const selectedFiles = (files) => { 
        setformFiles(files);
    }
    const handleApiUploadInformationCallSuccess = (encryptedData) => {
        let data = decryptData(encryptedData.data);
        setUploadInformation(data.mediaInfo);
        let allowedFiles = data.mediaInfo.allowedFiles;
        let mimeTypes = [];
        let allowedExtension = [];
        let allowedExtensionAsString = '';
        Object.keys(allowedFiles).map((extension, key)=> {
            mimeTypes.push(allowedFiles[extension])
            allowedExtension.push(extension.substring(1));
            allowedExtensionAsString += key == 0 ? extension.substring(1): ', '+extension.substring(1);
        });
        setAllowedMimeTypes(mimeTypes);
        setAllowedExtension(allowedExtension);
        setAllowedExtensionAsString(allowedExtensionAsString);
    }
    const handleApiCallSuccess = (data) => {
        getUploadData();
        setTimeout(getMediaUploadInformation, 2000);
        setAlert({ type: 'success', message: data.message});
        clearAlertMessage();
        
    };
    const clearAlertMessage = () => {
        setTimeout(function () {
            setAlert({ type: '', message: "" });
        }, 5000);
    }
    
    const handleApiCallError = (errorMessage) => {
        setAlert({ type: 'error', message: errorMessage });
        clearAlertMessage();
    };
    const uploadSelectedFiles = async () => { 
        try {
            if(formFiles.length==0){
                setAlert({ type: 'error', message: "Please select atleast a file" });
                setTimeout(function () {
                    setAlert({ type: '', message: "" });
                }, 5000);
                return false;
            }
            formFiles.forEach(async(file, index) => {
                getFileType(file).then(async(res) => {
                    const selectedFileType = res;
                    const aFileType = file?.type != '' ? file?.type : selectedFileType;
                    if (!allowedMimeTypes.includes(aFileType)) {
                        setAlert({ type: 'error', message: "This File type not allowed." });
                        clearAlertMessage();
                        return;
                    }
                    let validateSize =  validateFileSize(file.size);
                    if(validateSize){
                        const requestData = {
                            file: file
                        };
                        await makeApiCall({
                            requestData,
                            onSuccess: handleApiCallSuccess,
                            onError: handleApiCallError,
                            requestType: 'POST',
                            url: 'uploadFile',
                            responseType : 'json', 
                            loader : true,
                            multipart:true,
                        });
                    } else {
                        setAlert({ type: 'error', message: 'Your current space exceeding the allowed limit.'});
                    }
                });
            });
            

        } catch (error) {
            console.log(error)
            console.error('API call error:', error);
        }
    };
    //validating the size of the use allocated directory.
    const validateFileSize =  (filSize) => { 
        try {
            let usedSpace = uploadInformation.currentSpaceUsed;
            let maxSpace = uploadInformation.maxSpace;
            const fileSizeInMB = filSize / (1024 * 1024);
            return ( fileSizeInMB+usedSpace < maxSpace ) ? true : false;
        } catch (error) {
            console.log(error)
            console.error('API call error:', error);
        }
    };
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xl" id="uploadFileModal">
            <Modal.Header>Add File</Modal.Header>
            <Modal.Body>
                <MDBRow>
                    <MDBCol size='12'>
                        {alert.type === 'success' && <SuccessAlert success={true} messages={[alert.message]} resetAlert={setAlert} />}
                        {alert.type === 'error' && <ErrorAlert error={true} messages={[alert.message]} resetAlert={setAlert} />}
                    </MDBCol>
                    <MDBCol size='12'>
                        <DragDrop selectedFiles={selectedFiles} allowedMimeTypes={allowedMimeTypes}/>
                    </MDBCol>
                    <MDBCol size='12' className='mt-2'>
                        {uploadInformation.currentSpaceUsed != undefined && <ProgressBar currentSpaceUsed={uploadInformation.currentSpaceUsed} maxSpace={uploadInformation.maxSpace} remainingSpace={uploadInformation.remainingSpace} />}
                        <p className='mt-3'>Allowed File Types: {allowedExtensionAsString}</p>
                    </MDBCol>
                </MDBRow>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={uploadSelectedFiles}>
                    Save
                </Button>
                <Button color='secondary' onClick={onClose}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UploadFile;
